import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-a-component"
    }}>{`Creating a component`}</h1>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install encodable global-box
`}</code></pre>
    <h2 {...{
      "id": "define-encoding-configuration"
    }}>{`Define encoding configuration`}</h2>
    <p>{`First define the encoding channels of the component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`type LineChartEncodingConfig = {
  // channelName: [ChannelType, output type, support multiple fields or not]
  x: ['X', number];
  y: ['Y', number];
  color: ['Color', string];
  tooltip: ['Text', string, 'multiple'];
};
`}</code></pre>
    <p>{`Then creates an encoder factory once.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const lineChartEncoderFactory = createEncoderFactory<LineChartEncodingConfig>({
  // This part is manual work to convert the \`ChannelType\` defined in \`LineChartEncodingConfig\` above
  // from \`type\` to \`value\`. \`LineChartEncodingConfig\` is the source of truth
  // and because it is generic for this function, type checking will ensure the only compatible value
  // for channelTypes is exactly like the one below.
  channelTypes: {
    x: 'X',
    y: 'Y',
    color: 'Color',
    tooltip: 'Text',
  },
  // Define default definition for each channel
  defaultEncoding: {
    x: { type: 'quantitative', field: 'x' },
    y: { type: 'quantitative', field: 'y' },
    color: { value: 'black' },
    tooltip: [],
  },
});

type LineChartEncoding = DeriveEncoding<LineChartEncodingConfig>;
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`factory`}</inlineCode>{` encapsulates `}<inlineCode parentName="p">{`channelTypes`}</inlineCode>{` and `}<inlineCode parentName="p">{`defaultEncoding`}</inlineCode></p>
    <ul>
      <li parentName="ul">{`which are constants across all `}<inlineCode parentName="li">{`Encoder`}</inlineCode>{` instance of this chart`}</li>
      <li parentName="ul">{`making it convenient to create a new `}<inlineCode parentName="li">{`Encoder`}</inlineCode>{` from `}<inlineCode parentName="li">{`encoding`}</inlineCode>{` because `}<inlineCode parentName="li">{`factory.create(encoding)`}</inlineCode>{`
only needs one argument: `}<inlineCode parentName="li">{`encoding`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`This is how consumer-specified `}<inlineCode parentName="p">{`encoding`}</inlineCode>{` may look like.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const encoding: LineChartEncoding = {
  x: { type: 'quantitative', field: 'speed', scale: { domain: [0, 100] } },
  y: { type: 'quantitative', field: 'price' },
  color: { type: 'nominal', field: 'brand' },
  tooltip: [{ field: 'make' }, { field: 'model' }],
};
`}</code></pre>
    <h2 {...{
      "id": "implement-rendering-logic"
    }}>{`Implement rendering logic`}</h2>
    <p>{`Then create an `}<inlineCode parentName="p">{`Encoder`}</inlineCode>{` for the incoming `}<inlineCode parentName="p">{`encoding`}</inlineCode>{` and use it to facilitate rendering.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const encoder = lineChartEncoderFactory.create(encoding);
encoder.channels.x.getValueFromDatum({ speed: 100 }); // 100
encoder.channels.x.encodeDatum({ speed: 100 }); // 1
encoder.getGroupBys(); // ['brand', 'make', 'model']
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      